import { connect } from 'react-redux';
import { showFavouritedByModal } from '../Modals/redux/actionCreators';
import { getUserStreamContents } from './redux/selectors';
import { initializeUserStream } from './redux/actions';
const mapStateToProps = (state, { deviation, userListType })=>getUserStreamContents(state, userListType, deviation);
const mapDispatchToProps = {
    initialize: initializeUserStream,
    showFavouritedByModal
};
export default connect(mapStateToProps, mapDispatchToProps);
